import { app } from '../../../../app';
import { Controller } from './manage-bulk.controller';

app.component('companySharingCenterManageBulkAccounts', {
	bindings: {
        companyId: '<',
        labels$: '<',
        selectedAccounts: '<'
    },
    controller: Controller,
    templateUrl: require('./manage-bulk.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/manage-bulk/manage-bulk.component.js